<template>
	<div class="index-box">
		<div class="fullPageContainer" id="fullPageContainer" ref="fullPageContainer" @mousewheel="mouseWheelHandle" @DOMMouseScroll="mouseWheelHandle">
			<div class="touch" id="touch"></div>
			<div v-for="(item,index) in pageList" :key="index" class="index-video-box">
				<video class="index-video" muted   :id="'index-video' + (index + 1)" @loadeddata="setVideoPoster($event)" :autoplay="true" loop :controls="false" :webkit-playsinline="true" :playsinline="true" :x5-playsinline="true"
				 :x-webkit-airplay="true"  preload="auto" x5-video-player-type="h5" :x5-video-player-fullscreen="true" crossorigin="anymous" type="video">
					<source :src="item.cover" type="video/mp4">
					<!-- <source src="../assets/imgs/shoubaio2.mp4" type="video/mp4"> -->
				</video>
				<div class="swiper-slide u-flex-col u-col-center u-row-center" :class="fullpage.current == (index + 1) ? 'active_video' : ''"  v-if="$locale == 'zh'">
					<span class="title slideUp">{{item.name}}</span>
					<span class="subtitle slideUp slideDelay2">{{item.description}}</span>
					<div class="more-btn slideUp slideDelay3"  style="z-index: 99">
						<span class="btns" @click="toinfo(item)">{{$t('查看更多')}}</span>
					</div>
					<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">
				</div>
				<div class="swiper-slide u-flex-col u-col-center u-row-center" :class="fullpage.current == (index + 1) ? 'active_video' : ''"  v-if="$locale == 'en'">
					<span class="title slideUp">{{item.nameEnglish}}</span>
					<span class="subtitle slideUp slideDelay2">{{item.descriptionEnglish}}</span>
					<div class="more-btn slideUp slideDelay3" style="z-index: 99">
						<span class="btns" @click="toinfo(item)">{{$t('查看更多')}}</span>
					</div>
					<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">
				</div>
				<div class="swiper-slide u-flex-col u-col-center u-row-center" :class="fullpage.current == (index + 1) ? 'active_video' : ''"  v-if="$locale == 'de'">
					<span class="title slideUp">{{item.nameGerman}}</span>
					<span class="subtitle slideUp slideDelay2">{{item.descriptionGerman}}</span>
					<div class="more-btn slideUp slideDelay3">
						<span class="btns" @click="toinfo(item)">{{$t('查看更多')}}</span>
					</div>
					<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">
				</div>
				<div class="swiper-btn u-flex-col u-col-center u-row-center" style="z-index: 99">
					<div class="btn-item" v-for="(a,b) in pageList" :key="b" :class="b == index ? 'btn_active' : ''" @click="tojump(b + 1)"></div>
				</div>
			</div>
		</div>
		<!-- <div style="position: fixed;z-index: 99999;top: 0;left: 0;white-space: pre-line;color: #fff;">
			{{height.scrollTop}}
			{{height.video2}}
			{{height.video3}}
		</div> -->
		<!-- 轮播图 -->
		<!-- <div class="index-video-box u-flex u-row-center u-col-center" @click="openurl(indexdata.aaaLink)">
			<video class="index-video" id="index-video1" :controls="false" autoplay playsinline muted preload="auto" x5-video-player-type="h5" webkit-playsinline="true" playsinline="true" :src="indexdata.aaa"></video>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'zh'">
				<span>{{indexdata.aaaTitle}}</span>
				<span>{{indexdata.aaaWa}}</span>
				<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">

			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'en'">
				<span>{{indexdata.aaaTitleEnglish}}</span>
				<span>{{indexdata.aaaTitleGerman}}</span>
				<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">

			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'de'">
				<span>{{indexdata.aaaWaEnglish}}</span>
				<span>{{indexdata.aaaWaGerman}}</span>
				<img src="../assets/imgs/down.png" class="arrow-down" alt="" style="width: 42px;height: 42px">

			</div>
		</div> -->
		<!-- 查询 -->
		<!-- <div class="index-video-box">
			<video class="index-video" id="index-video2" :autoplay="autoplay2" loop muted preload="auto" x5-video-player-type="h5" webkit-playsinline="true" playsinline="true" :src="indexdata.bbb"></video>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'zh'">
				<span>{{indexdata.bbbTitle}}</span>
				<span>{{indexdata.bbbWa}}</span>
				<span @click="tocheck">{{$t('甄别自己')}}></span>
			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'en'">
				<span>{{indexdata.bbbTitleEnglish}}</span>
				<span>{{indexdata.bbbWaEnglish}}</span>
				<span @click="tocheck">{{$t('甄别自己')}}></span>
			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'de'">
				<span>{{indexdata.bbbTitleGerman}}</span>
				<span>{{indexdata.bbbWaGerman}}</span>
				<span @click="tocheck">{{$t('甄别自己')}}></span>
			</div>
		</div> -->
		<!-- 介绍 -->
		<!-- <div class="jieshao-box" v-if="bannerlist.length > 0">
			<div class="jieshao-swiper">
				<div class="jieshao-title">
					{{$t('精利精品推荐')}}
				</div>
				pc
				<el-carousel trigger="click" indicator-position="none" class="pc-jieshao">
					<el-carousel-item v-for="(item,index) in bannerlist" :key="index">
						<div class="u-flex u-col-top u-row-between u-flex-wrap jieshao-box1">
							<div class="jieshao-item u-flex-col u-col-center" v-for="(a,b) in item" :key="b">
								<img :src="a.cover" alt="">
								<span class="span1" v-if="$locale == 'zh'">{{a.name}}</span>
								<span class="span1" v-if="$locale == 'en'">{{a.nameEnglish}}</span>
								<span class="span1" v-if="$locale == 'de'">{{a.nameGerman}}</span>
								
								<span class="span3" @click="openurl(a.link)">{{$t('探索')}}></span>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
				h5
				<el-carousel trigger="click" indicator-position="none" class="h5-jieshao">
					<el-carousel-item v-for="(item,index) in bannerlist1" :key="index">
						<div class="u-flex u-col-top u-row-between u-flex-wrap jieshao-box1">
							<div class="jieshao-item u-flex-col u-col-center">
								<img :src="item.cover" alt="">
								<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
								<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
								<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
								
								<span class="span3" @click="openurl(item.link)">{{$t('探索')}}></span>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div> -->
		<!-- 联系我们 -->
		<!-- <div class="index-video-box">
			<video class="index-video" id="index-video3" :autoplay="autoplay3" loop muted preload="auto" x5-video-player-type="h5" webkit-playsinline="true" playsinline="true" :src="indexdata.ccc"></video>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'zh'">
				<span>{{indexdata.cccTitle}}</span>
				<span>{{indexdata.cccWa}}</span>
				<span @click="tocontact_us">{{$t('联系我们')}}></span>
			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'en'">
				<span>{{indexdata.cccTitleEnglish}}</span>
				<span>{{indexdata.cccWaEnglish}}</span>
				<span @click="tocontact_us">{{$t('联系我们')}}></span>
			</div>
			<div class="swiper-slide u-flex-col u-col-center u-row-center" v-if="$locale == 'de'">
				<span>{{indexdata.cccTitleGerman}}</span>
				<span>{{indexdata.cccWaGerman}}</span>
				<span @click="tocontact_us">{{$t('联系我们')}}></span>
			</div>
		</div> -->
		<!-- 手表 -->
		<!-- <div class="shoubiao-box">
			<div class="shoubiao-title">
				<div class="top-title u-flex u-col-center">
					<img src="../assets/imgs/index1-1.png" alt="">
					<span v-if="$locale == 'zh'">{{indexdata.bbbTitle}}</span>
					<span v-if="$locale == 'en'">{{indexdata.bbbTitleEnglish}}</span>
					<span v-if="$locale == 'de'">{{indexdata.bbbTitleGerman}}</span>
				</div>
				<div class="down-title" v-if="$locale == 'zh'">
					{{indexdata.bbbWa}}
				</div>
				<div class="down-title" v-if="$locale == 'en'">
					{{indexdata.bbbWaEnglish}}
				</div>
				<div class="down-title" v-if="$locale == 'de'">
					{{indexdata.bbbWaGerman}}
				</div>
			</div>
			<div class="shoubiao-list">
				<div class="shoubiao-item u-col-center u-row-center" v-for="(item,index) in goodslist" :key="index" @click="toinfo(item)">
					<img :src='item.cover' alt="">
					<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
					<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
					<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
					<span class="span2">{{item.ccObj}}</span>
				</div>
			</div>
		</div> -->
		<!-- 店铺 -->
		<!-- <div class="shop-box">
			<div class="down-swiper">
				<div class="swiper-slide" @click="openurl(indexdata.cccLink)">
					<div class="span-box u-flex-col u-col-center u-row-center">
						<span class="span1" v-if="$locale == 'zh'">{{indexdata.cccTitle}}</span>
						<span class="span1" v-if="$locale == 'en'">{{indexdata.cccTitleEnglish}}</span>
						<span class="span1" v-if="$locale == 'de'">{{indexdata.cccTitleGerman}}</span>
						<span class="span2" v-if="$locale == 'zh'">{{indexdata.cccWa}}</span>
						<span class="span2" v-if="$locale == 'en'">{{indexdata.cccWaEnglish}}</span>
						<span class="span2" v-if="$locale == 'de'">{{indexdata.cccWaGerman}}</span>
					</div>
					<img :src="indexdata.ccc" alt="">
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import Swiper from "swiper"

	export default {
		data() {
			return {
				current: 0,
				myswiper: null,
				myshoubiao: null,
				bannerlist: [],
				bannerlist1: [],
				downbannerlist: [],
				goodslist: [],
				indexdata: {},
				autoplay1: true,
				autoplay2: true,
				autoplay3: true,

				height: {
					scrollTop: 0,
					video2: 0,
					video3: 0
				},
				pageList: [],
				isactive: true,
				fullpage: {
					current: 0,     //当前页面编号
					isScrolling: false,     //是否在滚动，
					deltaY: 0,      //判断往上还是往下
				},
				windowHeight: 0,
				clientY: 0,
			}
		},
		created() {
		
			this.getlist()
			
		},
		mounted() {
			window.addEventListener('scroll', this.mouseWheelHandle)
			
			var element = document.getElementById("touch");
			element.addEventListener('touchstart',this.scrollChange,)
			
			element.addEventListener('touchend',this.touchend,)
		},
		methods: {
			setVideoPoster(event) {
				let video = event.target;
				// video.height = video.clientHeight;
				let canvas = document.createElement("canvas"); // 创建 canvas
				const ctx = canvas.getContext("2d");
				video.currentTime = 1; // 第一帧
				video.oncanplay = () => {
					canvas.width = video.clientWidth; // 获取视频宽度
					canvas.height = video.clientHeight; //获取视频高度
					var img = new Image(); // 这里使用img是为了解决视频跨域 canvas.toDataURL会提示错误的问题
					img.onload = function () {
						// canvas绘图
						ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
						// 转换成base64形式并设置封面
						video.poster = canvas.toDataURL("image/jpeg", 1); // 截取后的视频封面
					}
				}
			},
			// 监听页面滑动
			handleScroll() {
				console.log('滑动');
				var that = this
				that.windowHeight = document.documentElement.clientHeight
				this.scroll_top = document.documentElement.scrollTop
				// that.windowHeight = document.documentElement.clientHeight;
				// if(this.scroll_top > 200 && this.scroll_top < that.windowHeight && !that.flag) {
				// 	that.down_icon = true
				// } else  {
				// 	that.down_icon = false
				// }
			},
			tojump(index) {
				if(this.fullpage.current == index) {
					return
				}
				this.fullpage.current = index
				this.directToMove(index)
			},
			 // 向下切换
			next() {
				let len = this.pageList.length
				if(this.fullpage.current + 1 <= len) {
					this.fullpage.current += 1
					this.move(this.fullpage.current)
				}
			},
			// 往上切换
			pre() {
				if(this.fullpage.current > 1) {
					this.fullpage.current -= 1
					this.move(this.fullpage.current)
				}
			},
			move(index) {
				this.fullpage.isScrolling = true
				this.directToMove(index)
				setTimeout(() => {
					this.fullpage.isScrolling = false

				}, 1000);
			},
			directToMove(index) {
				// form = `translateY(${scrollHeight})`
				document.querySelector('#index-video' + index).scrollIntoView({
						block: 'start',
						behavior: 'smooth'
					})
					
			},
			mouseWheelHandle(event) {
				this.isactive = true
				let evt = event || window.event
				if(evt.stopPropageation) {
						evt.stopPropageation()
				} else {
						evt.returnValue = false
				}
				if(this.fullpage.isScrolling) {
						return false
				}
				let e = event.originalEvent || event
				this.fullpage.deltaY = e.deltaY || e.detail
				if(this.fullpage.deltaY > 0) {
						this.next()
				} else if(this.fullpage.deltaY < 0) {
						this.pre()
				}
			},
			touchend(event) {
				
				event.preventDefault();
				var touches = event.changedTouches;
				for (var i = 0; i < touches.length; i++) {
					var clientHeight = document.documentElement.clientHeight
					var clientY2 = touches[i].clientY
					if(Math.abs(clientY2 - this.clientY) < clientHeight *0.2) {
						return
					}
					if(clientY2 - this.clientY > clientHeight*0.2) {
						this.pre()
					} else {
						this.next()
					}
				}
			},
			scrollChange(event) {
				for(var i=1;i<=this.pageList.length;i++) {
					document.getElementById('index-video' + i).play()
				}
				/* document.getElementById('index-video1').play()
				document.getElementById('index-video2').play()
				document.getElementById('index-video3').play()
				document.getElementById('index-video4').play()
				document.getElementById('index-video5').play() */
				event.preventDefault();
				var touches = event.changedTouches;
				for (var i = 0; i < touches.length; i++) {
					this.clientY = touches[i].clientY
					
				}
			},
			getlist() {
				this.$http.get('/api/Index/getSlideshowEnableList').then((res) => {
					this.pageList = res.result
					setTimeout(() => {
						this.fullpage.current = 1
					}, 500);
				})
			},
			getindex() {
				this.$http.post('/api/Index/indexInfo').then(res => {
					this.indexdata = res.result
					this.$nextTick(() => {
						document.getElementById("index-video1").currentTime = 2
						// document.getElementById("index-video2").currentTime = 1
						// document.getElementById("index-video3").currentTime = 1
						setTimeout(() => {
							document.getElementById("index-video1").play()
							var elevideo = document.getElementById("index-video1");
							elevideo.addEventListener('ended', function() { //结束
								elevideo.play()
							}, false);
						}, 500)
					})

				})
			},
			toinfo(item) {
				this.$router.push({
					path: "/list",
					query: {
						id: item.seriesId
					}
				})
			},
			getgoods() {
				this.$http.post('/api/Index/getShowC').then(res => {
					this.goodslist = res.result
				})
			},
			getdownbanner() {
				this.$http.post('/api/Index/getPoster').then(res => {
					this.downbannerlist = res.result
				})
			},
			openurl(url) {
				window.open(url)
			},
			getbanner() {
				this.$http.post('/api/Index/getBanner').then(res => {
					var arr = []
					this.bannerlist = []
					this.bannerlist1 = res.result
					res.result.forEach((val, key) => {
						arr.push(val)
						if (arr.length == 2 || key == (res.result.length - 1)) {
							this.bannerlist.push(arr)
							arr = []
						}
					})
				})
			},
			tocheck() {
				this.$router.push({
					path: '/check'
				})
			},
			tocontact_us() {
				this.$router.push({
					path: '/contact_us'
				})
			},
		},
	}
</script>

<style lang="scss">
	@import url("../../node_modules/swiper/swiper.min.css");
	.slideUp {
				opacity: 0;
				transition: All 0.6s linear;
				-webkit-transition: All 0.6s linear;
				-moz-transition: All 0.6s linear;
				-o-transition: All 0.6s linear;
				transform: translateY(30px);
				-webkit-transform: translateY(30px);
				-moz-transform: translateY(30px);
			}
</style>
